// import React from 'react'
import React from 'react'
import cx from 'classnames'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import TemplateSidebar from '../templateSidebar'
import funride from '../../lib/funride/funride.module.less'
import { GLOBALS} from '../../types'

TemplateMain.defaultProps = {
  htmlTitle: 'Home'
}
interface TemplateMainProps {
  g_section:string,
  linksTitle:string,
  innerPage:React.ReactNode,
  g_sidebarKey:string,
  g_slideshowKey:string,
  htmlTitle:string
}

/* exported TemplateMain */
export default function TemplateMain (props:TemplateMainProps) {
  const portfolioUrl = `/portfolio/${GLOBALS.lastClient}/splash`
  return (
    <div id={funride.wrapper}>
      <Helmet>
        <title>Greg Sandell - {props.htmlTitle}</title>
      </Helmet>
      <header id={funride.header}>
        <div id={funride.logo}>
          <h1><Link to='/'>Greg Sandell</Link></h1>
          <h2>Web Software Engineer</h2>
        </div>
        {/* end div#logo */}
        <nav id={funride.menu}>
          <ul>
            <li className={cx({ [funride.active]: props.g_section === 'home' })}><Link
              to='/home'>Home</Link></li>
            <li className={cx({ [funride.active]: props.g_section === 'resume' })}><Link
              to='/resume'>Resume</Link></li>
            <li className={cx({ [funride.active]: props.g_section === 'portfolio' })}><Link
              to={portfolioUrl}>Portfolio</Link></li>
            <li className={cx({ [funride.active]: props.g_section === 'code' })}><Link
              to='/code'>Code</Link></li>
            <li className={cx({ [funride.active]: props.g_section === 'music' })}><Link
              to='/music'>Music</Link></li>
            {/*<li className={cx({ [funride.active]: props.g_section === 'blogs' })}><Link*/}
            {/*  to='/blog'>Blog</Link></li>*/}
            <li className={cx({ [funride.active]: props.g_section === 'more' })}><Link
              to='/more'>More...</Link></li>
          </ul>
        </nav>
        {/* end div#menu */}
      </header>
      {/* end div#header */}
      <main id={funride.page}>
        <div id={funride.content}>
          <div id={funride.welcome}>
            {props.innerPage ? props.innerPage : null}
          </div>
        </div>
        {/* end div#content */}
        <aside id={funride.sidebar}>
          <TemplateSidebar
            g_section={props.g_section}
            linksTitle={props.linksTitle}
            g_slideshowKey={props.g_slideshowKey}
            g_sidebarKey={props.g_sidebarKey}
          />
        </aside>
        {/* end div#sidebar */}
        <div id={funride.templateMainClearBoth} />
      </main>
      {/* end div#page */}
      <footer id={funride.footer}>
        <p>Copyright &copy; 2007-2023 Greg Sandell. All Rights Reserved.</p>
      </footer>
      {/* end div#footer */}
    </div>
  )
}
